import React from 'react';

const SelectAppTableRow = ({ appItem, handleAppToggle }) => {
    // console.log(appItem)
    return (
        <tr>
            {appItem[0]?.map((app) => {
                return (
                    <td className="v-middle" key={app?.appUuid}>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={app?.appUuid}
                                name={app?.appUuid}
                                checked={app?.timeAppMonitoringStatus || false}
                                onChange={(e) => handleAppToggle(e, app?.appUuid)}
                            />
                            <label
                                className="form-check-label d-inline-flex align-items-center"
                                htmlFor={app?.appUuid}
                            >
                                <span className="icon-wrap icon-sm me-2 p-0">
                                    <img src={app?.image} alt="avatar" />
                                </span>
                                {app?.app_name}
                            </label>
                        </div>
                    </td>
                )
            })}
        </tr>

        // <tr>
        //     <td className="v-middle">
        //         <div className="form-check">
        //             <input
        //                 className="form-check-input"
        //                 type="checkbox"
        //                 id='one'
        //             />
        //             <label
        //                 className="form-check-label d-inline-flex align-items-center"
        //                 for="one"
        //             >
        //                 <span className="icon-wrap icon-sm me-2 p-0">
        //                     <img src={candyCrushPic} alt="avatar"></img>
        //                 </span>
        //                 Android Auto
        //             </label>
        //         </div>
        //     </td>
        //     <td className="v-middle">
        //         <div className="form-check">
        //             <input
        //                 className="form-check-input"
        //                 type="checkbox"
        //                 id='one'
        //             />
        //             <label
        //                 className="form-check-label d-inline-flex align-items-center"
        //                 for="one"
        //             >
        //                 <span className="icon-wrap icon-sm me-2 p-0">
        //                     <img src={candyCrushPic} alt="avatar"></img>
        //                 </span>
        //                 Android Auto
        //             </label>
        //         </div>
        //     </td>
        //     <td className="v-middle">
        //         <div className="form-check">
        //             <input
        //                 className="form-check-input"
        //                 type="checkbox"
        //                 id='one'
        //             />
        //             <label
        //                 className="form-check-label d-inline-flex align-items-center"
        //                 for="one"
        //             >
        //                 <span className="icon-wrap icon-sm me-2 p-0">
        //                     <img src={candyCrushPic} alt="avatar"></img>
        //                 </span>
        //                 Android Auto
        //             </label>
        //         </div>
        //     </td>
        // </tr>
    )
}

export default SelectAppTableRow